module.exports = __webpack_public_path__ + "static/szenario3_3-c5295bf829e4ae160258430f14d80573.png";